// extracted by mini-css-extract-plugin
module.exports = {"contextualMenuItem":"ContextualMenuItem_contextualMenuItem__3bwN8","text":"ContextualMenuItem_text__O1EaZ"};